export default {
    configuration: false,
    searchList: {
        // fieldTrim 为 true 时 对查询条件字段值进行 trim 而不是 替换空白字符
        fieldTrim: true,
        searchTxt: [
            {
                name: '批量选择',
                value: 'batchQueryValue',
                type: 'input',
                placeholder: '支持批量查询，英文逗号或空格分开',
                selectConfig: {
                    width: '85px',
                    prop: 'batchQueryKey',
                    value: 'customerOrderNoList',
                    option: [
                        { label: '客户订单号', prop: 'customerOrderNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '运输单号', prop: 'taskNoList', placeholder: '支持批量查询，英文逗号或空格分开' }, // 批量
                        { label: '运单号', prop: 'waybillNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '物流单号', prop: 'orderNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '集配单号', prop: 'collectNoList', placeholder: '集配单号' },
                        { label: '京东VC号', prop: 'jdvcList', placeholder: '支持批量查询，英文逗号或空格分开' }, // 批量
                        { label: '合同编号', prop: 'contractNoList', placeholder: '支持批量查询，英文逗号或空格分开' },
                        { label: '集拼单号', prop: 'assembleNoList', placeholder: '支持批量查询，英文逗号或空格分开' }
                    ]
                },
                unfold: true,
                span: 5
            },
            {
                name: '签收状态',
                value: 'signStatusList',
                type: 'select',
                optionNum: 'SIGN_STATUS',
                multiple: true,
                unfold: true,
                options: [],
                span: 3
            },
            {
                name: '上传状态',
                value: 'receiptStatus',
                type: 'select',
                optionNum: 'SYS_TMS_UPLOAD_STATUS',
                options: [],
                unfold: true,
                span: 3
            },
            {
                name: '是否逾期',
                value: 'receiptOverdue',
                type: 'select',
                optionNum: 'TMS_YES_OR_NO',
                unfold: true,
                options: [],
                span: 3
            },
            {
                name: '创建时间',
                value: 'searchTime',
                type: 'time',
                unfold: true,
                span: 5,
                timeNum: 2,
                startPlaceholder: '创建开始时间',
                endPlaceholder: '创建结束时间'
            },
            {
                name: '要求签收时间',
                value: 'requestSignTime',
                type: 'time',
                unfold: true,
                span: 5,
                startPlaceholder: '要求签收开始时间',
                endPlaceholder: '要求签收结束时间'
            },
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '是否完好',
                value: 'signIsFull',
                type: 'select',
                optionNum: 'DISTRIBUTION_LAST_FLAG',
                unfold: true,
                span: 3
            },
            {
                name: '服务平台',
                value: 'siteName',
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', 'value': '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' }
                ],
                method: 'post',
                prefix: '/api-tms',
                advanceUrl: '/user/auth/data/site/query',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                type: 'advance',
                unfold: true,
                span: 4
            },
            {
                name: '客户',
                value: 'customerName',
                prop: 'customerName',
                type: 'advance',
                readOnly: false,
                multiple: true,
                maxSelect: 5,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'ebcuNameCn', 'value': '客户名称'
                },
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称' }
                ],
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                unfold: true,
                span: 4
            },
            {
                name: '来源系统',
                value: 'sourceSystem',
                optionNum: 'SOURCE_SYSTEM',
                type: 'select',
                options: [],
                filterable: true,
                unfold: true,
                span: 3
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 220,
        selectBtn: true,
        hasMaxBtnNum: true,
        maxBtnNum: 4,
        clickState: false,
        columns: [
            {
                label: '运输单号',
                prop: 'taskNo',
                width: 180,
                sort: true
            },
            {
                label: '运单号',
                prop: 'waybillNo',
                width: 180,
                sort: true
            },
            {
                label: '客户订单号',
                prop: 'customerOrderNo',
                width: 200,
                sort: true
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                width: 180,
                sort: true
            },
            {
                label: '京东VC单号',
                prop: 'jdVcNo',
                width: '120px',
                sort: true
            },
            {
                label: '要求抵达时间',
                prop: 'requireArriveTime',
                width: '160px',
                sort: true
            },
            {
                label: '上传状态',
                prop: 'receiptStatus',
                type: 'select',
                optionNum: 'SYS_TMS_UPLOAD_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '签收状态',
                prop: 'signStatus',
                type: 'select',
                optionNum: 'SIGN_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '审批状态',
                prop: 'applyStatus',
                type: 'select',
                options: [
                    { label: '新建', value: 'N' },
                    { label: '审核中', value: 'R' },
                    { label: '审核通过', value: 'P' },
                    { label: '作废', value: 'C' }
                ],
                sort: true,
                width: 120
            },
            {
                label: '运费类型',
                prop: 'deliverypayType',
                type: 'select',
                optionNum: '',
                options: [
                    { value: 1, label: '寄付' },
                    { value: 2, label: '到付' }
                ],
                sort: true,
                width: 120
            },
            {
                label: '运费收款状态',
                prop: 'transportFeeStatus',
                type: 'select',
                optionNum: 'OTP_TRANSPORT_FEE_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '发货地市',
                prop: 'senderCityName',
                width: '120px',
                sort: true
            },
            {
                label: '发货地区',
                prop: 'senderDistrictName',
                width: '120px',
                sort: true
            },
            {
                label: '发货地乡镇',
                prop: 'senderTownName',
                width: '120px',
                sort: true
            },
            {
                label: '目的地省',
                prop: 'receiverProvinceName',
                width: '120px',
                sort: true
            },
            {
                label: '目的地市',
                prop: 'receiverCityName',
                width: '120px',
                sort: true
            },
            {
                label: '目的地区',
                prop: 'receiverDistrictName',
                width: '120px',
                sort: true
            },
            {
                label: '目的地乡镇',
                prop: 'receiverTownName',
                width: '120px',
                sort: true
            },
            {
                label: '客户',
                prop: 'customerName',
                width: 180,
                sort: true
            },
            {
                label: '合同编号',
                prop: 'contractNo',
                width: 180,
                sort: true
            },
            {
                label: '回单印鉴',
                prop: 'seal',
                type: 'button',
                width: '110px',
                sort: true
            },
            {
                label: '是否完好',
                prop: 'signIsFull',
                type: 'select',
                optionNum: 'TMS_YES_OR_NO',
                options: [],
                width: 120,
                sort: true
            },
            {
                label: 'AI识别附件结果',
                prop: 'aiResult',
                type: 'select',
                optionNum: 'TMS_AI_RESULT',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: 'AI识别附件描述',
                prop: 'aiDescription',
                width: 160,
                sort: true
            },
            {
                label: 'AI识别重合率(%)',
                prop: 'aiOverlap',
                width: 160,
                sort: true
            },
            {
                label: 'AI自动签收结果',
                prop: 'abnormalAiResult',
                type: 'select',
                optionNum: 'TMS_AI_RESULT',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: 'AI自动签收描述',
                prop: 'abnormalAiDescription',
                width: 160,
                sort: true
            },
            {
                label: '是否重推',
                prop: 'isRePush',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                width: 100,
                sort: true
            },
            {
                label: '是否本人签收',
                prop: 'signBySelfFlag',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                width: 100,
                sort: true
            },
            {
                label: '签收人电话号码',
                prop: 'signContactPhone',
                type: 'desensitized', // 脱敏
                width: 180,
                sort: true
            },
            {
                label: '物流单号',
                prop: 'orderNo',
                width: 180,
                sort: true
            },
            {
                label: '集配单号',
                prop: 'collectNo',
                width: 180,
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                width: 180,
                sort: true
            },
            {
                label: '发车单状态',
                sort: true,
                type: 'select',
                optionNum: 'DISPATCH_STATUS',
                options: [],
                prop: 'dispatchStatus',
                width: 120
            },
            {
                label: '要求回单时间',
                sort: true,
                prop: 'requestFileDate',
                width: 150
            },
            {
                label: '要求签收时间',
                sort: true,
                prop: 'requestSignDate',
                width: 150
            },
            {
                label: '任务状态',
                prop: 'taskStatus',
                type: 'select',
                optionNum: 'TRANSPORT_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '签收类型',
                prop: 'deliveredVerifyFlag',
                type: 'select',
                optionNum: 'DELIVERED_VERIFY_FLAG',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '抵达时间',
                prop: 'arrivalTime',
                sort: true,
                width: 150
            },
            {
                label: '营销中心',
                prop: 'salesCenterName',
                width: 200
            },
            {
                label: '项目分类',
                prop: 'projectClassify',
                type: 'select',
                optionNum: 'PROJECT_CLASSIFY',
                options: [],
                sort: true,
                width: 150
            },
            {
                label: '总重量(kg)',
                prop: 'totalGrossWeight',
                width: '150px'
            },
            {
                label: '总方量(m³)',
                prop: 'totalVolume',
                width: '150px'
            },
            {
                label: '签收人',
                prop: 'signContact',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 120
            },
            {
                label: '签收时间',
                prop: 'signTime',
                sort: true,
                width: 150
            },
            {
                label: '签收方式',
                prop: 'signType',
                type: 'select',
                optionNum: 'SIGN_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true,
                width: 180
            },
            {
                label: '拒签原因',
                prop: 'rejectMark',
                sort: true,
                width: 180
            },
            {
                label: '快递异常签收',
                prop: 'deliveryRemark',
                sort: true,
                width: 160
            },
            {
                label: '上传时间',
                prop: 'electronicTime',
                sort: true,
                width: 150
            },
            {
                label: '上传方式',
                prop: 'receiptSource',
                type: 'select',
                optionNum: 'SYS_TMS_UPLOAD_WAY',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '上传人',
                prop: 'uploadPerson',
                sort: true,
                width: 150
            },
            {
                label: '业务模式',
                prop: 'businessMode',
                type: 'select',
                optionNum: 'BUSINESS_MODE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: 'VP客户标识',
                prop: 'vipFlag',
                type: 'select',
                optionNum: 'TMS_VIP_FLAG',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 180
            },
            {
                label: '发车时间',
                prop: 'actDepartTime',
                sort: true,
                width: 150
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                options: [],
                sort: true,
                width: 180
            },
            {
                label: '订单类型',
                prop: 'orderTypeName',
                sort: true,
                width: 120
            },
            {
                label: '收货单位',
                prop: 'upperReceiverName',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 180
            },
            {
                label: '上游订单类型',
                prop: 'upperOrderType',
                type: 'input',
                sort: true,
                width: 180
            },
            {
                label: '来源系统',
                prop: 'sourceSystem',
                type: 'select',
                optionNum: 'SOURCE_SYSTEM',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '包件数',
                prop: 'totalPkgQty',
                sort: true,
                width: 100
            },
            {
                label: '是否下发',
                prop: 'carrierVisibleFlag',
                type: 'select',
                optionNum: 'CARRIER_VISIBLE_FLAG',
                options: [],
                sort: true,
                width: 100
            },
            {
                label: '收货人姓名',
                prop: 'receiverName',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 120
            },
            {
                label: '收货人地址',
                prop: 'receiverDetailAddr',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 180
            },
            {
                label: '收货人手机号码',
                prop: 'receiverMobile',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 120
            },
            {
                label: '收货人固定电话',
                type: 'desensitized', // 脱敏
                prop: 'receiverTel',
                sort: true,
                width: 120
            },
            {
                label: '司机',
                prop: 'driver',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 120
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                type: 'desensitized', // 脱敏
                sort: true,
                width: 120
            },
            {
                label: '是否分拨订单',
                prop: 'distributionFlag',
                type: 'select',
                sort: true,
                optionNum: 'DISTRIBUTION_FLAG',
                options: [],
                width: 120
            },
            {
                label: '是否最后一次分拨',
                prop: 'distributionLastFlag',
                type: 'select',
                optionNum: 'DISTRIBUTION_LAST_FLAG',
                options: [],
                sort: true,
                width: 150
            },
            {
                label: '是否违规卸货',
                prop: 'isIllegalUnload',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                sort: true,
                width: 150
            },
            {
                label: '是否上传违规卸货图片',
                prop: 'illegalUnloadPicUpload',
                type: 'select',
                optionNum: '',
                options: [
                    { label: '是', value: 'Y' },
                    { label: '否', value: 'N' }
                ],
                sort: true,
                width: 150
            },
            {
                label: '2C批量直配',
                prop: 'b2cZpFlag',
                type: 'select',
                options: [
                    { label: '是', value: '1' },
                    { label: '否', value: '0' }
                ],
                sort: true,
                width: 110
            },
            {
                label: '场景标识',
                prop: 'loanScenarioCode',
                type: 'select',
                optionNum: 'CUSTOMER_SCENCE',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '配送方式',
                prop: 'deliveryType',
                type: 'select',
                sort: true,
                optionNum: 'DELIVERY_TYPE',
                options: [],
                width: 120
            },
            {
                label: '任务类型',
                prop: 'taskType',
                type: 'select',
                optionNum: 'TASK_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '出入库类型',
                prop: 'inOutType',
                type: 'select',
                optionNum: 'OTP_IN_OUT_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '分拨段号',
                prop: 'distributionNum',
                sort: true,
                width: 120
            },
            {
                label: '实发数量',
                prop: 'totalQty',
                sort: true,
                width: 120
            },
            {
                label: '实收数量',
                prop: 'realReceiveCount',
                sort: true,
                width: 120
            },
            {
                label: '客户期望送达时间(终)',
                prop: 'expectEndTime',
                sort: true,
                width: 180
            },
            {
                label: '是否代收货款',
                prop: 'collectionFlag',
                type: 'select',
                optionNum: 'COLLECTION_FLAG',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '签收距离',
                prop: 'signDistanceName',
                sort: true,
                width: 120
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 120
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 150
            },
            {
                label: '最后修改人',
                prop: 'updateUserName',
                sort: true,
                width: 120
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                sort: true,
                width: 150
            },
            {
                label: '移交时间',
                prop: 'transferTime',
                sort: true,
                width: 150
            },
            {
                label: '要求回单移交时间',
                prop: 'requestReceiptTransferTime',
                sort: true,
                width: 150
            },
            {
                label: '是否逾期',
                prop: 'receiptOverdue',
                type: 'select',
                optionNum: 'TMS_YES_OR_NO',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '上楼费标识',
                prop: 'upstairsCharge',
                type: 'select',
                optionNum: 'TMS_YES_OR_NO',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '卸货费标识',
                prop: 'unloadCharge',
                type: 'select',
                optionNum: 'TMS_YES_OR_NO',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '部分签收',
                prop: 'receiptPartFlag',
                type: 'select',
                optionNum: 'LSP_RECEIPT_PART_FLAG',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '审批链接',
                prop: 'requestUrl',
                type: 'button',
                sort: true,
                width: 180
            },
            {
                label: '零担订单号',
                prop: 'lqId',
                sort: true,
                width: 180
            },
            {
                label: '附件',
                prop: 'files',
                type: 'photos',
                width: '80px'
            },
            {
                label: '佐证状态',
                prop: 'evidenceStatus',
                type: 'select',
                optionNum: 'OTP_TMS_EVIDENCE_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '佐证附件上传',
                prop: 'evidenceFile',
                type: 'button',
                sort: true,
                width: 130
            },
            {
                label: '佐证审核明细',
                prop: 'evidenceCheckRemark',
                sort: true,
                width: 180
            },
            {
                label: '事业部',
                prop: 'entityId',
                type: 'select',
                optionNum: 'OMS_PARAMS_ENTITY_ID',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '订单服务类型',
                prop: 'serviceType',
                type: 'select',
                optionNum: 'ORDER_SERVICE_TYPE',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '合单码',
                prop: 'consolidationOrderNo',
                sort: true,
                width: 180
            },
            {
                label: '打印箱贴',
                prop: 'printBoxLabel',
                type: 'select',
                optionNum: '',
                options: [
                    { value: '1', label: '是' },
                    { value: '0', label: '否' }
                ],
                sort: true,
                width: 160
            },
            {
                label: '仓库名称',
                prop: 'whName',
                sort: true,
                width: 180
            },
            {
                label: '电商分类',
                prop: 'commerceCategories',
                type: 'select',
                optionNum: 'OMS_E_COMMERCE_CATEGORIES',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '货款收款状态',
                prop: 'goodsFeeStatus',
                type: 'select',
                optionNum: 'OTP_TRANSPORT_FEE_STATUS',
                options: [],
                sort: true,
                width: 120
            },
            {
                label: '客户属性',
                prop: 'customerAttribute',
                type: 'select',
                options: [],
                optionNum: 'LMDM_CUSTOMER_CHANNEL',
                sort: true,
                width: 120
            },
            {
                label: '包裹数',
                prop: 'sumPackages',
                sort: true,
                width: 160
            },
            {
                label: '车牌号',
                prop: 'vehicleCard',
                sort: true,
                width: 160
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 160
            },
            {
                label: '集拼单号',
                prop: 'assembleNo',
                sort: true,
                width: 200
            },
            {
                label: '直通宝SN图片校验结果',
                prop: 'picCheckFlag',
                type: 'select',
                width: 170,
                options: [
                    { label: '校验通过', value: 'Y' },
                    { label: '校验失败', value: 'N' }
                ]
            }
        ],
        action: [
            // {
            //     type: 'text',
            //     label: '签收',
            //     size: 'mini',
            //     event: 'receipt',
            //     ifHas: '150203001'
            // },
            // {
            //     type: 'text',
            //     label: '拒收',
            //     size: 'mini',
            //     event: 'reject',
            //     ifHas: '150203002'
            // },
            // {
            //     type: 'text',
            //     label: '逾期登记',
            //     size: 'mini',
            //     event: 'overdueRegister',
            //     ifHas: '150203003'
            // },
            {
                type: 'text',
                label: '回单上传',
                size: 'mini',
                event: 'uploadFile',
            },
            // {
            //     type: 'text',
            //     label: '重推',
            //     size: 'mini',
            //     event: 'rePush',
            //     ifHas: '150203009'
            // },
            // {
            //     type: 'text',
            //     label: '反查',
            //     size: 'mini',
            //     event: 'recheck',
            //     ifHas: '150203012'
            // },
            // {
            //     type: 'text',
            //     label: '签收改拒收',
            //     size: 'mini',
            //     event: 'change',
            //     ifHas: '150203011'
            // },
            // {
            //     type: 'text',
            //     label: '逾期明细查询',
            //     size: 'mini',
            //     event: 'overdueDetailQuery',
            //     ifHas: '150203004'
            // },
            // {
            //     type: 'text',
            //     label: '增值费修改',
            //     size: 'mini',
            //     event: 'chargeEdit',
            //     ifHas: '150203013'
            // }
            {
                type: 'text',
                label: '预签收',
                size: 'mini',
                event: 'preReceipt'
            },
            {
                type: 'text',
                label: '预签收日志',
                size: 'mini',
                event: 'preReceiptLog'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 100,
        pageSizes: [10, 20, 30, 50, 100, 200]
    },
    searchTotalTitle: [
        {
            name: '签收时间',
            value: 'receiptSignTime',
            type: 'time',
            startPlaceholder: '签收开始时间',
            endPlaceholder: '签收结束时间'
        },
        {
            name: '要求回单时间',
            value: 'requestFileDate',
            type: 'time',
            startPlaceholder: '要求回单开始时间',
            endPlaceholder: '要求回单结束时间'
        },
        {
            name: '上传时间',
            value: 'electronicUploadTime',
            type: 'time',
            startPlaceholder: '上传开始时间',
            endPlaceholder: '上传结束时间'
        },
        {
            name: '抵达时间',
            value: 'arrivalTime',
            type: 'time',
            startPlaceholder: '抵达起始时间',
            endPlaceholder: '抵达结束时间'
        },
        {
            name: '移交时间',
            value: 'transferTime',
            type: 'time',
            startPlaceholder: '移交起始时间',
            endPlaceholder: '移交结束时间'
        },
        {
            name: '要求回单移交时间',
            value: 'requestReceiptTransferTime',
            type: 'time',
            startPlaceholder: '要求回单移交起始时间',
            endPlaceholder: '要求回单移交结束时间'
        },
        {
            name: '发货地市',
            value: 'senderCityName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地市名称' },
                { 'prop': 'ebplCode', 'value': '发货地市编码' }
            ],
            cbParams: [
                'ebplCode#senderCityCode', 'ebplNameCn#senderCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'senderCityCode'
        },
        {
            name: '发货地区',
            value: 'senderDistrictName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地区名称' },
                { 'prop': 'ebplCode', 'value': '发货地区编码' }
            ],
            cbParams: [
                'ebplCode#senderDistrictCode', 'ebplNameCn#senderDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'senderDistrictCode'
        },
        {
            name: '发货地乡镇',
            value: 'senderTownName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            tableConfig: [
                { 'prop': 'ebplNameCn', 'value': '发货地乡镇名称' },
                { 'prop': 'ebplCode', 'value': '发货地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#senderTownCode', 'ebplNameCn#senderTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'senderTownCode'
        },
        {
            name: '目的地省',
            value: 'receiverProvinceName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地省名称' },
                { prop: 'ebplCode', 'value': '目的地省编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地省名称' },
                { prop: 'ebplCode', 'value': '目的地省编码' }
            ],
            cbParams: [
                'ebplCode#receiverProvinceCode',
                'ebplNameCn#receiverProvinceName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_PROVINCE&ebplParentPmCode=100000',
            advanceCode: 'receiverProvinceCode'
        },
        {
            name: '目的地市',
            value: 'receiverCityName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地市名称' },
                { prop: 'ebplCode', 'value': '目的地市编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地市名称' },
                { prop: 'ebplCode', 'value': '目的地市编码' }
            ],
            cbParams: [
                'ebplCode#receiverCityCode',
                'ebplNameCn#receiverCityName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
            advanceCode: 'receiverCityCode'
        },
        {
            name: '目的地区',
            value: 'receiverDistrictName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地区名称' },
                { prop: 'ebplCode', 'value': '目的地区编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地区名称' },
                { prop: 'ebplCode', 'value': '目的地区编码' }
            ],
            cbParams: [
                'ebplCode#receiverDistrictCode',
                'ebplNameCn#receiverDistrictName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
            advanceCode: 'receiverDistrictCode'
        },
        {
            name: '目的地乡镇',
            value: 'receiverTownName',
            type: 'advance',
            advanceConfig: [
                { prop: 'ebplNameCn', 'value': '目的地乡镇名称' },
                { prop: 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            tableConfig: [
                { prop: 'ebplNameCn', 'value': '目的地乡镇名称' },
                { prop: 'ebplCode', 'value': '目的地乡镇编码' }
            ],
            cbParams: [
                'ebplCode#receiverTownCode',
                'ebplNameCn#receiverTownName'
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
            advanceCode: 'receiverTownCode'
        },
        {
            name: '运费类型',
            value: 'deliverypayType',
            type: 'select',
            options: [
                { value: 1, label: '寄付' },
                { value: 2, label: '到付' }
            ]
        },
        {
            name: '运费收款状态',
            value: 'transportFeeStatus',
            type: 'select',
            optionNum: 'OTP_TRANSPORT_FEE_STATUS',
            options: []
        },
        {
            name: '任务类型',
            value: 'taskType',
            type: 'select',
            optionNum: 'TASK_TYPE',
            options: []
        },
        {
            name: '客户属性',
            value: 'customerAttributeList',
            type: 'select',
            multiple: true,
            filterable: true,
            optionNum: 'LMDM_CUSTOMER_CHANNEL',
            options: []
        },
        {
            name: '收货人姓名',
            value: 'receiverName',
            type: 'input'
        },
        {
            name: '营销中心',
            value: 'salesCenterName',
            type: 'input'
        },
        {
            name: '收货人手机号码',
            value: 'receiverMobile',
            type: 'input'
        },
        {
            name: '是否重推',
            value: 'isRePush',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否本人签收',
            value: 'signBySelfFlag',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否违规卸货',
            value: 'isIllegalUnload',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '是否上传违规卸货图片',
            value: 'illegalUnloadPicUpload',
            type: 'select',
            optionNum: '',
            options: [
                { label: '是', value: 'Y' },
                { label: '否', value: 'N' }
            ]
        },
        {
            name: '场景标识',
            value: 'loanScenarioCodeList',
            type: 'select',
            multiple: true,
            filterable: true,
            maxSelect: 10,
            optionNum: 'CUSTOMER_SCENCE',
            options: []
        },
        {
            name: '审批状态',
            value: 'applyStatus',
            type: 'select',
            optionNum: '',
            options: [
                { label: '新建', value: 'N' },
                { label: '审核中', value: 'R' },
                { label: '审核通过', value: 'P' },
                { label: '作废', value: 'C' }
            ]
        },
        {
            name: '签收类型',
            value: 'deliveredVerifyFlag',
            type: 'select',
            optionNum: 'DELIVERED_VERIFY_FLAG',
            options: []
        },
        {
            name: '配送方式',
            value: 'deliveryTypeList',
            type: 'select',
            optionNum: 'DELIVERY_TYPE',
            options: [],
            multiple: true
        },
        {
            name: '发车单状态',
            value: 'dispatchStatusList',
            type: 'select',
            optionNum: '',
            options: [
                { label: '在途', value: '40' },
                { label: '抵达', value: '50' },
                { label: '待签收', value: '60' },
                { label: '完成', value: '100' }
            ],
            multiple: true
        },
        {
            name: '任务状态',
            value: 'taskStatusList',
            type: 'select',
            optionNum: '',
            options: [
                { label: '在途', value: '40' },
                { label: '抵达', value: '50' },
                { label: '上传回单', value: '55' },
                { label: '待签收', value: '60' },
                { label: '待移交', value: '70' },
                { label: '已移交', value: '75' },
                { label: '取消抵达', value: '80' },
                { label: '完成', value: '100' },
                { label: '已拒收', value: '200' },
                { label: '取消', value: '999' }
            ],
            multiple: true
        },
        {
            name: '项目分类',
            value: 'projectClassify',
            type: 'select',
            optionNum: 'PROJECT_CLASSIFY'
        },
        {
            name: 'VP客户标识',
            value: 'vipFlagList',
            optionNum: 'TMS_VIP_FLAG',
            type: 'select',
            multiple: true,
            filterable: true,
            options: []
        },
        {
            name: '电商分类',
            value: 'commerceCategories',
            type: 'select',
            optionNum: 'OMS_E_COMMERCE_CATEGORIES',
            options: []
        },
        {
            name: '上传方式',
            value: 'receiptSource',
            type: 'select',
            optionNum: 'SYS_TMS_UPLOAD_WAY'
        },
        {
            name: '业务模式',
            value: 'businessMode',
            type: 'select',
            optionNum: 'BUSINESS_MODE'
        },
        // {
        //     name: '承运商',
        //     value: 'carrierName',
        //     type: 'advance',
        //     multiple: true,
        //     border: true,
        //     dialogWidth: '800px',
        //     multipleTableColumn: {
        //         prop: 'supplierNameCn',
        //         value: '承运商名称'
        //     },
        //     advanceConfig: [
        //         { prop: 'supplierNameCn', value: '承运商名称' },
        //         { prop: 'supplierCode', value: '承运商编码' }
        //     ],
        //     tableConfig: [
        //         { prop: 'supplierNameCn', value: '承运商名称' },
        //         { prop: 'supplierCode', value: '承运商编码' }
        //     ],
        //     advanceNotSearch: true,
        //     queryConditionRequired: true,
        //     method: 'post',
        //     prefix: '/api-tms',
        //     advanceUrl: '/srm/supplier/search',
        //     cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
        // },
        {
            name: '采购渠道',
            value: 'procurementChannel',
            type: 'select',
            optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL'
        },
        {
            name: '订单类型',
            value: 'orderTypeList',
            type: 'select',
            optionNum: 'ORDER_TYPE',
            multiple: true
        },
        {
            name: '收货单位',
            value: 'upperReceiverName',
            type: 'input'
        },
        {
            name: '上游订单类型',
            value: 'upperOrderType',
            type: 'input'
        },
        {
            name: '实际签收人',
            value: 'signContact',
            type: 'input'
        },
        {
            name: '司机',
            value: 'driver',
            type: 'input'
        },
        {
            name: '司机联系方式',
            value: 'driverContactWay',
            type: 'input'
        },
        {
            name: '是否分拨订单',
            value: 'distributionFlag',
            type: 'select',
            optionNum: 'DISTRIBUTION_FLAG'
        },
        {
            name: '是否最后一次分拨',
            value: 'distributionLastFlag',
            type: 'select',
            optionNum: 'DISTRIBUTION_LAST_FLAG'
        },
        {
            name: '零担订单号',
            value: 'lqId',
            type: 'input'
        },
        {
            name: '佐证状态',
            value: 'evidenceStatus',
            type: 'select',
            optionNum: '',
            options: [
                { label: '待上传', value: '0' },
                { label: '审核中', value: '1' },
                { label: '确认', value: '2' },
                { label: '驳回', value: '3' }
            ]
        },
        {
            name: '收货人电话后四位',
            value: 'receiverMobileSuffix',
            type: 'input'
        },
        {
            name: '事业部',
            value: 'entityId',
            type: 'select',
            optionNum: 'OMS_PARAMS_ENTITY_ID',
            options: [],
            filterable: true
        },
        {
            name: '合单码',
            value: 'consolidationOrderNo',
            type: 'input'
        },
        {
            name: '打印箱贴',
            value: 'printBoxLabel',
            type: 'select',
            optionNum: '',
            options: [
                { value: '1', label: '是' },
                { value: '0', label: '否' }
            ]
        },
        {
            name: '2C批量直配',
            value: 'b2cZpFlagList',
            type: 'select',
            multiple: true, // 多选
            options: [
                { label: '是', value: '1' },
                { label: '否', value: '0' }
            ]
        },
        {
            name: '仓库',
            value: 'whName',
            multiple: true,
            border: true,
            multipleTableColumn: {
                prop: 'cdwhName',
                value: '仓库名称'
            },
            advanceConfig: [
                { prop: 'cdwhName', value: '仓库名称' },
                { prop: 'whCode', value: '仓库编码' }
            ],
            tableConfig: [
                { prop: 'whCode', value: '仓库编码' },
                { prop: 'cdwhName', value: '仓库名称' }
            ],
            advanceUrl: 'cdWarehouse/search?cdwhIsStop=0',
            cbParams: ['whCode', 'cdwhName#whName'],
            type: 'advance'
        },
        {
            name: '是否代收货款',
            value: 'collectionFlag',
            type: 'select',
            optionNum: 'COLLECTION_FLAG',
            options: []
        },
        {
            name: '货款收款状态',
            value: 'goodsFeeStatus',
            type: 'select',
            optionNum: 'OTP_TRANSPORT_FEE_STATUS',
            options: []
        },
        {
            name: '车牌号',
            value: 'vehicleCard',
            type: 'input'
        },
        {
            name: '订单服务类型',
            value: 'serviceTypeList',
            type: 'select',
            optionNum: 'ORDER_SERVICE_TYPE',
            options: [],
            multiple: true
        },
        {
            name: 'AI识别附件结果',
            value: 'aiResult',
            type: 'select',
            optionNum: 'TMS_AI_RESULT',
            options: []
        },
        {
            name: 'AI自动签收结果',
            value: 'abnormalAiResult',
            type: 'select',
            optionNum: 'TMS_AI_RESULT',
            options: []
        },
        {
            name: 'SN码校验是否通过',
            value: 'picCheckFlag',
            type: 'select',
            options: [
                { label: '通过', value: 'Y' },
                { label: '不通过', value: 'N' }
            ],
            multiple: false
        }
    ]
};
